import { Component, OnInit } from '@angular/core';
import { AnalyticsService, BankAccountsService, CashboxService } from '@common/services';
import { UserService } from '@modules/auth/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, map, Observable, take } from 'rxjs';

@Component({
    selector: 'fina-cashbox-open',
    templateUrl: './cashbox-open.component.html',
    styleUrls: ['./cashbox-open.component.scss'],
})
export class CashboxOpenComponent implements OnInit {
    cajaAmount = 0;
    private cashAccount: any = null;
    private hasLoadedAccounts = false;

    constructor(
        public activeModal: NgbActiveModal,
        public cashboxService: CashboxService,
        private analyticsService: AnalyticsService,
        public userService: UserService,
        private bankAccountsService: BankAccountsService,
    ) {}

    ngOnInit() {
        // Load bank accounts data once
        this.loadBankAccounts();
    }

    loadBankAccounts() {
        this.bankAccountsService
            .getBankAccounts$()
            .pipe(take(1))
            .subscribe({
                next: (response: any) => {
                    try {
                        const bankAccounts = response && response.data ? response.data : [];
                        this.cashAccount = bankAccounts.find((account: any) => account && account.name === 'Caja Efectivo');
                        this.hasLoadedAccounts = true;
                    } catch (error) {
                        console.error('Error processing bank accounts:', error);
                    }
                },
                error: error => {
                    console.error('Error fetching bank accounts:', error);
                    this.hasLoadedAccounts = true;
                },
            });
    }

    closeModal() {
        this.cashboxService.openedFromScFinish = false;
        this.activeModal.dismiss('cancel');
    }

    validateAmount(event: any) {
        const input = event.target.value;
        // Check if input exceeds 10 digits before decimal or 2 digits after decimal
        const parts = input.split('.');
        if (parts[0] && parts[0].length >= 11) {
            event.target.value = parts[0].substring(0, 10) + (parts[1] ? '.' + parts[1] : '');
            this.cajaAmount = parseFloat(event.target.value);
        }
        if (parts[1] && parts[1].length > 2) {
            event.target.value = parts[0] + '.' + parts[1].substring(0, 2);
            this.cajaAmount = parseFloat(event.target.value);
        }
    }

    openCashbox() {
        // Basic validation (the form validation should catch these cases)
        if (this.cajaAmount < 0) {
            return;
        }

        // Check for insufficient funds
        if (this.insufficientFunds()) {
            alert('¡Fondos insuficientes! La cantidad introducida es mayor que el saldo disponible en la cuenta Caja Efectivo.');
            return;
        }

        // Pass amount to service
        this.cashboxService.createCashBox(this.cajaAmount).subscribe({
            next: createdCashbox => {
                this.analyticsService.analyticsCapture('cashbox_opened');
                this.cashboxService.openedFromScFinish = false;
                this.activeModal.close(createdCashbox);
            },
            error: err => {
                this.cashboxService.openedFromScFinish = false;
                this.activeModal.dismiss(err);
            },
        });
    }

    insufficientFunds(): boolean {
        // If we haven't loaded accounts yet or couldn't find the cash account, return false
        if (!this.hasLoadedAccounts || !this.cashAccount) {
            return false;
        }

        // Check if the amount exceeds the cash account balance
        const availableAmount = this.cashAccount.balance !== undefined ? this.cashAccount.balance : this.cashAccount.totalUSD || 0;

        return this.cajaAmount > availableAmount;
    }
}
